import { post } from './http';

const baseUrl = process.env.VUE_APP_CALLBACK_URL;

// 百度投放回调
const baiduCallback = (params) => post(`${baseUrl}/collect/docreport`, params);

export default {
  baiduCallback,
}
